import styled, { css } from 'styled-components'

import { Accordion, AccordionContents, AccordionHeaderWrapper, AccordionTitle, AccordionWrapper } from '@Components/CMS/Accordion'
import { AccordionSidePane, SidepaneAccordion } from '@Components/CMS/AccordionSidePane'
import { TitleWrapper } from '@Components/CMS/Title'
import { up } from '@Globals/Style/breakpoints'

export const SizeGuideWrapper = styled.div(() => css`
  ${AccordionTitle} {
    text-transform: none;
  }

  > ${AccordionWrapper} > ${AccordionHeaderWrapper} {
    ${up('mobileStyleThreshold')} {
      padding-left: 0;
    }
  }

  ${SidepaneAccordion} {
    margin-top: -10px;
    border-top: none;
  }

  ${AccordionContents} {
    margin-left: 0;
    margin-right: 0;
  }

  ${TitleWrapper} {
    h3 {
      text-align: center;
      font-size: 15px;
      margin-bottom: 30px;
      margin-top: 0;
    }
  }
`)

export const StyledAccordionSidePane = styled(AccordionSidePane)(() => css`
  ${AccordionHeaderWrapper} {
    // Them there 11px be a magic number, corresponding to the size selector's internal padding
    padding-left: 11px;

    ${up('mobileStyleThreshold')} {
      padding-left: 15px;
    }
  }
`)

export const StyledGuideAccordion = styled(Accordion)(({ theme }) => css`
  border: 1px solid ${theme.colors.greyLight};

  ${AccordionHeaderWrapper} {
    background: white;
  }

  ${AccordionContents} {
    border-top: 1px solid ${theme.colors.greyLight};
    border-left: 0;
    margin: 0;
    overflow: hidden;
  }
`)

export const SizeTableTable = styled.table(({ theme }) => css`
  width: 100%;
  border-collapse: collapse;

  td, th {
    text-align: left;
    font-size: .8rem;
    padding: ${theme.padding.phablet};
    border-right: 1px solid ${theme.colors.greyLight};
    border-bottom: 1px solid ${theme.colors.greyLight};

    &:last-child {
      border-right: none;
    }
  }

  thead {
    th {
      font-weight: bold;
    }
  }

  tbody {
    tr {
      &:nth-child(odd) {
        background: ${theme.colors.greyLightest};
      }

      th, td {
        border-bottom: 1px solid ${theme.colors.greyLight};
      }

      &:last-child {
        th, td {
          border-bottom: none;
        }
      }
    }
  }

`)
